module.exports = __webpack_public_path__ + "img/lu.367b9a1c.jpg";